<template>
    <div class="container-fluid">
        <div class="row row-separate">
            <DetailsCard
                class="col-sm-6 col-md-4"
                :title="__('Stored Weight')"
                :unit="dashboardDetails.warehouseStoragedWeightUnit"
                :weight="dashboardDetails.warehouseStoragedWeight"
                icon="icon-kg"
            />
            <DetailsCard
                class="col-sm-6 col-md-4"
                :title="__('Incoming Shipments')"
                :unit="dashboardDetails.shipmentArrivalWeightUnit"
                :weight="dashboardDetails.shipmentArrivalWeight"
                icon="icon-truck"
            />
            <DetailsCard
                class="col-sm-6 col-md-4"
                :count="dashboardDetails.releasesCount"
                :title="__('Releases')"
                @click.native="$router.push('/releases')"
                icon="icon-transfer"
                style="cursor: pointer"
            />
            <!--<DetailsCard
                class="col-sm-6 col-md-3"
                :count="dashboardDetails.unpaidInvoicesCount"
                :title="__('Non taxable accounts')"
                @click.native="$router.push('/invoices')"
                icon="icon-file"
                style="cursor: pointer"
            />-->
        </div>

        <div class="clearfix"><br/></div>

        <div class="row row-fit">
            <div class="col-sm-12 col-md-12">
                <Card>
                    <LoadsCharts @chartFilter="filterChart"/>
                </Card>
            </div>

         
        </div>

        <div class="clearfix"><br/></div>

        <div class="row">
           <div class="col-sm-6 col-md-6">
                <Card>
                    <LoadsBySpeciesTotal ref="LoadsBySpeciesTotal"/>
                </Card>
            </div>
            <div class="col-sm-6 col-md-6">
                <Card>
                    <LoadsBySpecies ref="LoadsBySpecies"/>
                </Card>
            </div>
        </div>

        <MessageBox/>
    </div>
</template>

<script>
import { $api } from '../../services/api'
import MessageBox from '../Messages/MessageBox'
import DetailsCard from './DetailsCard'
import LoadsCharts from './LoadsCharts'
import TimeZone from './TimeZone'
import LoadsBySpecies from './LoadsBySpecies'
import LoadsBySpeciesTotal from './LoadsBySpeciesTotal'

export default {
  name: 'Home',

  components: {
    DetailsCard,
    LoadsBySpecies,
    LoadsBySpeciesTotal,
    TimeZone,
    LoadsCharts,
    MessageBox
  },

  beforeRouteEnter (to, from, next) {
    $api.dashboard.dashboardDetails().then((data) => {
      next((vm) => {
        vm.dashboardDetails = data
        vm.timelineEvents = data.timelineEvents
      })
    })
  },

  data () {
    return {
      timelineEvents: [],
      dashboardDetails: {
        warehouseStoragedWeightUnit: null,
        warehouseStoragedWeight: null,
        shipmentArrivalWeightUnit: null,
        shipmentArrivalWeight: null,
        releasesCount: null,
        unpaidInvoicesCount: null
      }
    }
  },

  methods: {
    filterChart (res) {
      this.$refs.LoadsBySpecies.filterChart(res)
    }
  }
}
</script>
